export const TOKEN_KEY_ADMIN = '@token_admin';
export const ID_KEY_ADMIN = '@idkey_admin';
export const USER_NAME_ADMIN = '@username_admin';
export const TOKEN_KEY_RESPONSAVELLEAD = '@token_responsavellead';
export const ID_KEY_RESPONSAVELLEAD = '@idkey_responsavellead';
export const USER_NAME_RESPONSAVELLEAD = '@username_responsavellead';
